import React, { useEffect, useState } from 'react';
import { PostingWorker, PostingJob, SetLoading } from '../Classes';
import { Button, Header, Message, Toast, Items, Icon, Input, Label } from 'react-frontier';
import { addCommas, bindClick } from '@tempu/components/Util';
import { firstBy } from 'thenby';
import Modal from './Modal';
import moment from 'moment';
import API from '../API';
import Validator from '@tempu/components/Validator';
interface Prospect{
	user_id: number, 
	name: string,
	email: string,
	phone: string, 
	zipcode: string, 
	worked: boolean, 
	working: boolean,
	rejected: boolean,
	applied: boolean,
	invited: boolean,
	image?: string,
	distance?: number
}

interface ModalProps {
	open: boolean,
	posting_id?: number,
	showPostings?: boolean,
	onClose: () => void,
	onWorkerAdded?: (worker: PostingWorker) => void,
}

var InviteModal = (props: ModalProps) => {
	var [modalPrompts, setModalPrompts] = useState<string[]>([]);
	var [postingJobs, setPostingJobs] = useState<PostingJob[]>(null);
	var [users, setUsers] = useState<Prospect[]>([]);
	var [selectedJob, setSelectedJob] = useState<PostingJob>(null);
	var [selectedUsers, setSelectedUsers] = useState<number[]>([]);
	var [loading, setLoading] = useState<boolean>(false);
	var [newUserModal, setNewUserModal] = useState<boolean>(false);
	var [userEmail, setUserEmail] = useState<string>(null);
	var [userModalPrompts, setUserModalPrompts] = useState<string[]>([]);

	useEffect(()=>{
		if(props.posting_id && !Number.isNaN(parseInt(props.posting_id.toString()))){
			getJobs();
		}
	}, []);

	var getJobs = ()=>{
		setLoading(true);
		API.getPostingJobs(props.posting_id).then(jobs=>{
			if(jobs.error) return 
			setPostingJobs(jobs.data);
		}).catch(err=>{
			return setModalPrompts(['Hubo un error cargando los puestos del negocio. (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	}

	var getProspects = async() =>{
		setLoading(true);
		API.postingProspectsList(props.posting_id).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			setUsers(res.data);
		}).catch(e=>{
			return setModalPrompts(['Hubo un error inesperado cargando los usuarios (LCL-1)']);
		}).finally(()=>{
			setLoading(false);
		})
	};

	var invite = async(setLoading: SetLoading)=>{
		setLoading(true);
		API.jobInviteUser(selectedJob.job_id, selectedUsers).then(res=>{
			if(res.error) return setModalPrompts([res.message]);
			Toast.success('Usuario invitado!');
			setSelectedJob(null);
			setSelectedUsers([]);
			props.onClose();
		}).catch(err=>{
			setModalPrompts(['Hubo un error al invitar al usuario. (PJC-1)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	var addUser = async(setLoading: SetLoading)=>{
		var { valid, prompts } = Validator({userEmail}, {
			userEmail: [{
				rule: 'email', label: 'Correo electrónico'
			}],
		});
		setUserModalPrompts(prompts);
		if(!valid) return;
		setLoading(true);

		API.getPostingInviteUser(userEmail, props.posting_id).then(res=>{
			if(res.error) return setUserModalPrompts([res.message]);
			var u = [...users];
			u.push(res.data);
			setUsers(u);
			selectedUsers.push(res.data.user_id);
			setNewUserModal(false);
			setUserEmail(null);
		}).catch(err=>{
			setModalPrompts(['Hubo un error al invitar al usuario. (PJC-2)']);
		}).finally(()=>{
			setLoading(false);
		});
	}

	var selectJob = (j: PostingJob)=>{
		setSelectedJob(j);
		getProspects();
	}

	return <> <Modal open={props.open} size='tiny' onClose={props.onClose}>
			<Modal.Header>{selectedJob ? 'Invitar usuario' : 'Seleccionar empleo'}</Modal.Header>
			<Modal.Content style={{ overflow: 'auto', maxHeight: 500 }} >
				{postingJobs?.length === 0 && !loading ? <Message type='info' text='El empleo no cuenta con puestos publicados.' /> : postingJobs && !selectedJob && !loading ? <>
					<Items
						selectable
						data={postingJobs}
						onSelected={(j) => selectJob(j)}
						valueExtractor={(j)=>j.job_id}
						render={j=>(
						<div style={{ display: 'flex', alignItems: 'center', padding: 10, borderBottom: '1px solid #eee' }}>
							<Icon name='user' style={{ marginRight: 10, fontSize: 20 }} />
							<div style={{ flex: 1 }}>
								<div style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 8 }}>
									{j.job_name}
								</div>
								<div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
									<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
											<Icon name='users' style={{ fontSize: 14, marginRight: 0 }} />
											<span style={{ fontSize: 14 }}>
												{j.job_users} / {j.job_count}
											</span>
									</div>
									<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
											<Icon name='money-bill-wave' style={{ fontSize: 14, marginRight: 0 }} />
											<span style={{ fontSize: 14 }}>
												{addCommas(j.pay_rate)}
											</span>
									</div>
								</div>
							</div>
						</div>
						)}
					/>
				</> : selectedJob && !loading && users?.length === 0 ?  <Message type='info' text='No se encontraron usuarios disponibles.' /> : selectedJob && !loading && users ? <>
					<Items
						data={[0]}
						onSelected={bindClick(setNewUserModal, true)}
						selectable
						render={()=>{
							return <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', padding: 15 }}>
								<Icon name='user-plus'/>
								<div className='info'>
									<div className='name' style={{ fontSize: 18, fontWeight: 'bold' }}>Invitar por correo</div>
								</div>
							</div>
						}}
					/>
					<Items
						toggle
						selectable
						data={users?.filter(u => !u.working && !u.applied && !u.invited).sort(firstBy('worked', 'desc').thenBy(u => u.distance, 'asc'))}
						selected={selectedUsers}
						onToggle={setSelectedUsers}
						valueExtractor={u=>u.user_id}
						render={u=>{
							return <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
								<Icon name='user'/>
								<div className='info'>
									<div className='name' style={{ fontSize: 16, fontWeight: 'bold' }}>{u.name}</div>
									<div className='name' style={{ fontSize: 14, color: 'gray' }}>{u.worked ? 'Extrabajador' : u.rejected ? 'Rechazado' : ''}</div>
									<div style={{ fontSize: 14 }}>{u.distance ? u.distance.toFixed(2) : 'N/A'} <b>km</b></div>
								</div>
							</div>
						}}
					/>
				</> : (
					<Header loading text='Cargando datos' /> 
				)}
				<Message type="error" list={modalPrompts} />
			</Modal.Content>
			<Modal.Actions>
				{selectedJob && <Button text='Regresar' basic color='black' iconName='arrow-left' onClick={() => setSelectedJob(null)}/>}
				<Button text='Cancelar' basic onClick={props.onClose}/>
				{selectedJob && selectedUsers.length !== 0 && <Button text='Invitar' color='black'  onClick={invite}/>}
			</Modal.Actions>
		</Modal>
		<Modal open={newUserModal} onClose={bindClick(setNewUserModal)} size='mini'>
			<Modal.Header>Invitar usuario</Modal.Header>
			<Modal.Content>
				<Input label='Correo electrónico' value={userEmail} onChange={setUserEmail}/>
				<Message type="error" list={userModalPrompts} />
			</Modal.Content>
			<Modal.Actions>
				<Button text='Cancelar' basic onClick={bindClick(setNewUserModal, false)}/>
				<Button text='Agregar' color='black' onClick={addUser}/>
			</Modal.Actions>
		</Modal>
	</>
}

export default InviteModal;